export default __webpack_public_path__ + "static/media/408.93985de6.jpg";